// ============================================================
// ⚙️ CONFIGURACIÓN DE PRODUCCIÓN - CONFIARÉ
// ============================================================
//
// Este archivo contiene TODAS las configuraciones externas
// del sitio. Edita los valores aquí antes de publicar.
//
// ============================================================

const productionConfig = {

  // ============================================================
  // 📊 GOOGLE TAG MANAGER
  // ============================================================
  // Obtén tu ID en: https://tagmanager.google.com/
  // El ID tiene formato: GTM-XXXXXXX
  // ============================================================
  googleTagManager: {
    enabled: false,                    // ← Cambiar a true cuando tengas el ID
    containerId: "GTM-XXXXXXX"         // ← Reemplaza con tu ID de GTM
  },

  // ============================================================
  // 📱 META PIXEL (Facebook Pixel)
  // ============================================================
  // Obtén tu ID en: https://business.facebook.com/events_manager
  // El ID es un número de ~15 dígitos
  // ============================================================
  metaPixel: {
    enabled: false,                    // ← Cambiar a true cuando tengas el ID
    pixelId: "000000000000000"         // ← Reemplaza con tu Pixel ID
  },

  // ============================================================
  // 🔒 CLOUDFLARE TURNSTILE (Anti-spam) - FRONTEND
  // ============================================================
  // Obtén tus keys en: https://dash.cloudflare.com/?to=/:account/turnstile
  // 1. Crea un nuevo widget
  // 2. Selecciona "Managed" como modo
  // 3. El Site Key va aquí (público)
  // 4. El Secret Key va en backend-php/config.php (privado)
  // ============================================================
  turnstile: {
    enabled: false,                    // ← Cambiar a true cuando tengas las keys
    siteKey: "0x0000000000000000000000000000000000"  // ← Tu Site Key (público)
  },

  // ============================================================
  // 📝 FORMULARIO DE CONTACTO
  // ============================================================
  // El endpoint apunta al archivo PHP que procesa el formulario
  // 
  // IMPORTANTE: Cambia la URL a tu dominio en producción
  // Ejemplo: "https://confiare.mx/api/contact.php"
  // ============================================================
  contactForm: {
    // Endpoint del formulario (PHP propio)
    // En desarrollo: null (modo demo)
    // En producción: "https://TU_DOMINIO.COM/api/contact.php"
    endpoint: null,
    
    // Para desarrollo local con PHP:
    // endpoint: "http://localhost:8080/api/contact.php"
  },

  // ============================================================
  // 🔍 SEO - CONFIGURACIÓN
  // ============================================================
  seo: {
    siteName: "CONFIARÉ",
    siteUrl: "https://confiare.mx",    // ← Tu dominio final
    title: "CONFIARÉ - Tu Aliado Financiero de Confianza",
    description: "Créditos personales, empresariales y factoraje en Ciudad Juárez. Aprobación rápida, asesoría gratuita y atención personalizada.",
    keywords: "créditos personales, créditos empresariales, factoraje, financiera, préstamos, Ciudad Juárez, Chihuahua, CONFIARÉ",
    ogImage: "/images/logo-confiare.png",
    locale: "es_MX",
    twitterHandle: "@confiare"
  }

};

// ============================================================
// EXPORTACIÓN - NO MODIFICAR
// ============================================================
export default productionConfig;
export const { googleTagManager, metaPixel, turnstile, contactForm, seo } = productionConfig;
